import { useCallback } from 'react';
import { useTenantContextValue } from './TenantContextProvider';
import { ALL_BRANCHES, TenantContext } from './types';

/**
 * Tenancy now travels in a cookie (see TenantContextProvider). `buildPath`
 * stays so navigation call sites keep compiling unchanged — it just returns
 * the leaf path only.
 */
export function useTenantContext(): TenantContext & { buildPath: (leaf: string) => string; isAggregate: boolean } {
  const { context } = useTenantContextValue();
  const buildPath = useCallback((leaf: string) => `/${leaf.replace(/^\//, '')}`, []);
  return { ...context, buildPath, isAggregate: context.branchId === ALL_BRANCHES };
}
